import { useState, useCallback, useMemo } from 'react';
import { HighnoteTransactionEvent } from 'API';

interface UseTransactionSheetsProps {
  transactions: HighnoteTransactionEvent[];
  defaultSheet?: 'details' | 'edit';
}

export const useTransactionSheets = ({
  transactions,
  defaultSheet = 'details',
}: UseTransactionSheetsProps) => {
  const [isTransactionDetailsOpen, setIsTransactionDetailsOpen] = useState(false);
  const [isEditTransactionOpen, setIsEditTransactionOpen] = useState(false);
  const [selectedTransactionId, setSelectedTransactionId] = useState<string | null>(null);

  const selectedTransaction = useMemo(
    () =>
      transactions.find((t) => t.id === selectedTransactionId || t.transactionId === selectedTransactionId),
    [transactions, selectedTransactionId]
  );

  const handleTransactionClick = useCallback(
    (id: string) => {
      setSelectedTransactionId(id);
      if (defaultSheet === 'details') {
        setIsTransactionDetailsOpen(true);
      } else {
        setIsEditTransactionOpen(true);
      }
    },
    [defaultSheet]
  );

  const handleCloseTransactionDetails = useCallback(() => {
    setIsTransactionDetailsOpen(false);
    setSelectedTransactionId(null);
  }, []);

  const handleOpenEditTransaction = useCallback(() => {
    setIsTransactionDetailsOpen(false);
    setIsEditTransactionOpen(true);
  }, []);

  const handleCloseEditTransaction = useCallback(() => {
    setIsEditTransactionOpen(false);
    setSelectedTransactionId(null);
  }, []);

  return {
    isTransactionDetailsOpen,
    isEditTransactionOpen,
    selectedTransaction,
    handleTransactionClick,
    handleCloseTransactionDetails,
    handleOpenEditTransaction,
    handleCloseEditTransaction,
  };
};
